export default "__VITE_ASSET__ed01ddd4__"